import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRightIcon as RightArrow } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Badge } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './allhomes-article-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
const LEFT_IMAGE_LINES = 3;
const DEFAULT_LINES = 2;
const AllhomesArticleCard = _ref => {
  let image = _ref.image,
    url = _ref.url,
    description = _ref.description,
    heading = _ref.heading,
    tags = _ref.tags,
    imagePosition = _ref.imagePosition,
    onClick = _ref.onClick,
    maxLines = _ref.maxLines,
    fixedHeight = _ref.fixedHeight,
    className = _ref.className,
    target = _ref.target,
    rel = _ref.rel,
    appearance = _ref.appearance;
  const _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  const handleClick = function handleClick() {
    sendEvent('article-click', {
      article: {
        heading,
        description,
        image,
        url,
        tags
      }
    });
    onClick(...arguments);
  };
  const isResearchAppearance = appearance === 'research';
  const isDefaultAppearance = appearance === 'default';
  const leftImage = !isResearchAppearance && imagePosition === 'left';
  return ___EmotionJSX("div", {
    css: styles.articleCard(isDefaultAppearance),
    className: className
  }, ___EmotionJSX("a", {
    href: url,
    css: styles.link(isResearchAppearance),
    target: target,
    rel: rel,
    onClick: handleClick
  }, image && !leftImage && ___EmotionJSX("div", {
    css: styles.topImageContainer(isResearchAppearance)
  }, ___EmotionJSX("img", {
    src: image,
    alt: ""
  })), ___EmotionJSX("div", {
    css: styles.content(isDefaultAppearance)
  }, image && leftImage && ___EmotionJSX("div", {
    css: styles.leftImageContainer
  }, ___EmotionJSX("img", {
    src: image,
    alt: ""
  })), ___EmotionJSX("div", {
    css: styles.middle(isResearchAppearance)
  }, heading && ___EmotionJSX("div", {
    css: styles.heading(isResearchAppearance)
  }, heading), ___EmotionJSX("div", {
    css: styles.description({
      fixedHeight,
      maxLines: maxLines || (leftImage && image ? LEFT_IMAGE_LINES : DEFAULT_LINES)
    })
  }, description), isDefaultAppearance && ___EmotionJSX("div", {
    css: styles.tags
  }, tags.filter(Boolean).map(item => ___EmotionJSX(Badge, {
    key: item,
    label: item,
    css: styles.tag
  })), fixedHeight && tags.filter(Boolean).length === 0 ? ___EmotionJSX("div", {
    css: styles.tags
  }, "\xA0") : null)), isDefaultAppearance && ___EmotionJSX("div", {
    css: styles.arrow
  }, ___EmotionJSX(RightArrow, {
    size: "regular"
  })))));
};
export const articleCardPropTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  target: PropTypes.string,
  rel: PropTypes.string,
  maxLines: PropTypes.number,
  fixedHeight: PropTypes.bool,
  imagePosition: PropTypes.string,
  className: PropTypes.string,
  onClick: () => {},
  appearance: PropTypes.oneOf(['research', 'default'])
};
AllhomesArticleCard.propTypes = articleCardPropTypes;
AllhomesArticleCard.defaultProps = {
  heading: null,
  description: '',
  image: '',
  url: '',
  tags: [],
  onClick: PropTypes.func,
  maxLines: null,
  fixedHeight: false,
  imagePosition: 'left',
  className: '',
  target: '',
  rel: '',
  appearance: 'default'
};
export default AllhomesArticleCard;